export enum StatusMessageTypes {
  ERROR = 'error',
  SUCCESS = 'success',
  WARNING = 'warning'
}
